<template lang="pug">
  .ads-contacts-list(:style="iconVariables")
    .ads-contacts-list__title {{ title }}
    .ads-contacts-list__content
      .ads-contacts-list__person(
        v-for="(contactPerson, index) of items"
        :key="index"
      )
        //AdsContactPicture(:url="getContactAvatar(contactPerson)")
        .ads-contacts-list__person-info
          .ads-contacts-list__person-description(
              v-html="getPersonInfo(contactPerson)"
            )
          .ads-contacts-list__contacts-wrapp
            .ads-contacts-list__contacts--other(v-if="getPersonContacts(contactPerson).other.length > 0" )
              a.ads-contacts-list__contact-link(
                v-for="(contact, index) of getPersonContacts(contactPerson).other"
                :key="index"
                :href="getHrefContact(contact)"
                :class="getClassContactLink(contact)"
                target="_blank"
              ) {{ getTextContact(contact) }}
            .ads-contacts-list__contacts--messengers(v-if="getPersonContacts(contactPerson).messengers.length > 0" )
              a.ads-contacts-list__contact-link(
                v-for="(contact, index) of getPersonContacts(contactPerson).messengers"
                :key="index"
                :href="getHrefContact(contact)"
                :class="getClassContactLink(contact)"
                target="_blank"
              ) {{ getTextContact(contact) }}
</template>

<script lang="ts">
  import type { PropOptions } from 'vue';
  // import AdsContactPicture from '~/components/content/components/AdsContactPicture.vue';

  const iconTg =
    "url(\"data:image/svg+xml,%3Csvg width='25' height='24' viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.28732 11.5182C9.45706 9.24158 16.1467 6.46592 17.0704 6.08167C19.4926 5.07624 20.2359 5.26874 19.8653 7.49578C19.5991 9.09646 18.8314 14.3953 18.219 17.6937C17.8559 19.6497 17.0408 19.8815 15.7599 19.0352C15.1438 18.628 12.0338 16.569 11.3586 16.0856C10.7425 15.6451 9.89268 15.115 10.9584 14.071C11.3378 13.6994 13.8236 11.3228 15.7606 9.47331C16.0143 9.23047 15.6955 8.83141 15.4026 9.02613C12.7919 10.7593 9.17232 13.1648 8.71155 13.478C8.0156 13.9511 7.34701 14.168 6.14739 13.823C5.24065 13.5624 4.35536 13.2514 4.01071 13.133C2.68314 12.6769 2.99821 12.0861 4.28732 11.5182Z' fill='%232962F9'/%3E%3C/svg%3E%0A\")";
  const iconTgBefore =
    "url(\"data:image/svg+xml,%3Csvg width='25' height='24' viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.28732 11.5182C9.45706 9.24158 16.1467 6.46592 17.0704 6.08167C19.4926 5.07624 20.2359 5.26874 19.8653 7.49578C19.5991 9.09646 18.8314 14.3953 18.219 17.6937C17.8559 19.6497 17.0408 19.8815 15.7599 19.0352C15.1438 18.628 12.0338 16.569 11.3586 16.0856C10.7425 15.6451 9.89268 15.115 10.9584 14.071C11.3378 13.6994 13.8236 11.3228 15.7606 9.47331C16.0143 9.23047 15.6955 8.83141 15.4026 9.02613C12.7919 10.7593 9.17232 13.1648 8.71155 13.478C8.0156 13.9511 7.34701 14.168 6.14739 13.823C5.24065 13.5624 4.35536 13.2514 4.01071 13.133C2.68314 12.6769 2.99821 12.0861 4.28732 11.5182Z' fill='%23264EB1'/%3E%3C/svg%3E%0A\")";
  const iconWhatsapp =
    "url(\"data:image/svg+xml,%3Csvg width='25' height='24' viewBox='0 0 25 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M18.4603 6.08864C16.8934 4.52769 14.81 3.66758 12.5902 3.66663C8.01598 3.66663 4.29349 7.37131 4.29166 11.9249C4.29112 13.3805 4.67315 14.8013 5.39928 16.0538L4.22198 20.3333L8.62113 19.1849C9.83318 19.843 11.1979 20.1897 12.5866 20.1903H12.5901H12.5902C17.1637 20.1903 20.8867 16.485 20.8887 11.9316C20.8894 9.72471 20.027 7.64969 18.4603 6.08864ZM12.5902 18.7954H12.5875C11.3496 18.7948 10.1357 18.4639 9.07693 17.8385L8.82495 17.6898L6.2144 18.3712L6.91139 15.8382L6.74721 15.5785C6.05672 14.4855 5.6922 13.2224 5.69272 11.9254C5.69424 8.14064 8.78823 5.06153 12.5928 5.06153C14.4352 5.06229 16.1668 5.77722 17.4691 7.07464C18.7714 8.37203 19.488 10.0967 19.4875 11.931C19.4858 15.7159 16.3917 18.7954 12.5902 18.7954Z' fill='%232962F9'/%3E%3Cpath d='M5.0553 19.5L6.11491 15.4343C5.4612 14.2445 5.11742 12.8945 5.11783 11.512C5.11955 7.18605 8.46996 3.66663 12.5866 3.66663C14.5846 3.66757 16.4598 4.48465 17.8697 5.96762C19.28 7.45058 20.0561 9.42176 20.0553 11.5181C20.0536 15.8441 16.703 19.3639 12.5869 19.3639C12.5866 19.3639 12.5871 19.3639 12.5869 19.3639H12.5835C11.3336 19.3635 10.1054 19.0337 9.01462 18.409L5.0553 19.5Z' fill='white'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M10.5074 8.22042C10.3538 7.85226 10.1921 7.84489 10.046 7.83844C9.92648 7.83292 9.78967 7.83326 9.65307 7.83326C9.51637 7.83326 9.29423 7.88865 9.10637 8.10987C8.9184 8.33109 8.38867 8.86587 8.38867 9.95353C8.38867 11.0413 9.12345 12.0923 9.22587 12.24C9.3284 12.3874 10.6443 14.6907 12.7283 15.5769C14.4602 16.3133 14.8127 16.1668 15.1886 16.13C15.5646 16.0931 16.4016 15.5953 16.5725 15.079C16.7434 14.5629 16.7434 14.1205 16.6921 14.028C16.6409 13.9359 16.5042 13.8806 16.2991 13.77C16.0941 13.6595 15.0861 13.1246 14.8981 13.0509C14.7102 12.9772 14.5735 12.9403 14.4367 13.1617C14.3 13.3828 13.9073 13.8806 13.7877 14.028C13.6681 14.1757 13.5485 14.1942 13.3434 14.0836C13.1384 13.9727 12.478 13.7395 11.6947 12.9864C11.0852 12.4005 10.6736 11.6768 10.554 11.4555C10.4344 11.2344 10.5412 11.1146 10.6441 11.0044C10.7361 10.9054 10.8491 10.7463 10.9516 10.6173C11.054 10.4882 11.0881 10.396 11.1565 10.2486C11.2248 10.101 11.1907 9.97192 11.1394 9.86137C11.0881 9.75082 10.6897 8.65755 10.5074 8.22042Z' fill='%232962F9'/%3E%3Cpath d='M18.4603 6.08864C16.8934 4.5277 14.81 3.6676 12.5902 3.66663C8.01597 3.66663 4.29349 7.37131 4.29165 11.9249C4.29111 13.3805 4.67314 14.8013 5.39926 16.0538L4.22198 20.3333L8.62114 19.1849C9.8332 19.843 11.1979 20.1897 12.5866 20.1903H12.5902C17.1636 20.1903 20.8867 16.4849 20.8886 11.9316C20.8894 9.72472 20.027 7.6497 18.4603 6.08864ZM12.5902 18.7955H12.5875C11.3496 18.7948 10.1357 18.464 9.07693 17.8385L8.82494 17.6898L6.2144 18.3712L6.91137 15.8382L6.7472 15.5785C6.05671 14.4855 5.69219 13.2224 5.69273 11.9255C5.69423 8.14066 8.78822 5.06156 12.5928 5.06156C14.4352 5.06232 16.1668 5.77725 17.4691 7.07466C18.7714 8.37207 19.488 10.0968 19.4875 11.9311C19.4858 15.7159 16.3917 18.7955 12.5902 18.7955Z' fill='%232962F9'/%3E%3C/svg%3E%0A\")";
  const iconWhatsappBefore =
    "url(\"data:image/svg+xml,%3Csvg width='25' height='24' viewBox='0 0 25 24' fill='%23264EB1' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M18.4603 6.08864C16.8934 4.52769 14.81 3.66758 12.5902 3.66663C8.01598 3.66663 4.29349 7.37131 4.29166 11.9249C4.29112 13.3805 4.67315 14.8013 5.39928 16.0538L4.22198 20.3333L8.62113 19.1849C9.83318 19.843 11.1979 20.1897 12.5866 20.1903H12.5901H12.5902C17.1637 20.1903 20.8867 16.485 20.8887 11.9316C20.8894 9.72471 20.027 7.64969 18.4603 6.08864ZM12.5902 18.7954H12.5875C11.3496 18.7948 10.1357 18.4639 9.07693 17.8385L8.82495 17.6898L6.2144 18.3712L6.91139 15.8382L6.74721 15.5785C6.05672 14.4855 5.6922 13.2224 5.69272 11.9254C5.69424 8.14064 8.78823 5.06153 12.5928 5.06153C14.4352 5.06229 16.1668 5.77722 17.4691 7.07464C18.7714 8.37203 19.488 10.0967 19.4875 11.931C19.4858 15.7159 16.3917 18.7954 12.5902 18.7954Z' fill='%23264EB1'/%3E%3Cpath d='M5.0553 19.5L6.11491 15.4343C5.4612 14.2445 5.11742 12.8945 5.11783 11.512C5.11955 7.18605 8.46996 3.66663 12.5866 3.66663C14.5846 3.66757 16.4598 4.48465 17.8697 5.96762C19.28 7.45058 20.0561 9.42176 20.0553 11.5181C20.0536 15.8441 16.703 19.3639 12.5869 19.3639C12.5866 19.3639 12.5871 19.3639 12.5869 19.3639H12.5835C11.3336 19.3635 10.1054 19.0337 9.01462 18.409L5.0553 19.5Z' fill='white'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M10.5074 8.22042C10.3538 7.85226 10.1921 7.84489 10.046 7.83844C9.92648 7.83292 9.78967 7.83326 9.65307 7.83326C9.51637 7.83326 9.29423 7.88865 9.10637 8.10987C8.9184 8.33109 8.38867 8.86587 8.38867 9.95353C8.38867 11.0413 9.12345 12.0923 9.22587 12.24C9.3284 12.3874 10.6443 14.6907 12.7283 15.5769C14.4602 16.3133 14.8127 16.1668 15.1886 16.13C15.5646 16.0931 16.4016 15.5953 16.5725 15.079C16.7434 14.5629 16.7434 14.1205 16.6921 14.028C16.6409 13.9359 16.5042 13.8806 16.2991 13.77C16.0941 13.6595 15.0861 13.1246 14.8981 13.0509C14.7102 12.9772 14.5735 12.9403 14.4367 13.1617C14.3 13.3828 13.9073 13.8806 13.7877 14.028C13.6681 14.1757 13.5485 14.1942 13.3434 14.0836C13.1384 13.9727 12.478 13.7395 11.6947 12.9864C11.0852 12.4005 10.6736 11.6768 10.554 11.4555C10.4344 11.2344 10.5412 11.1146 10.6441 11.0044C10.7361 10.9054 10.8491 10.7463 10.9516 10.6173C11.054 10.4882 11.0881 10.396 11.1565 10.2486C11.2248 10.101 11.1907 9.97192 11.1394 9.86137C11.0881 9.75082 10.6897 8.65755 10.5074 8.22042Z' fill='%23264EB1'/%3E%3Cpath d='M18.4603 6.08864C16.8934 4.5277 14.81 3.6676 12.5902 3.66663C8.01597 3.66663 4.29349 7.37131 4.29165 11.9249C4.29111 13.3805 4.67314 14.8013 5.39926 16.0538L4.22198 20.3333L8.62114 19.1849C9.8332 19.843 11.1979 20.1897 12.5866 20.1903H12.5902C17.1636 20.1903 20.8867 16.4849 20.8886 11.9316C20.8894 9.72472 20.027 7.6497 18.4603 6.08864ZM12.5902 18.7955H12.5875C11.3496 18.7948 10.1357 18.464 9.07693 17.8385L8.82494 17.6898L6.2144 18.3712L6.91137 15.8382L6.7472 15.5785C6.05671 14.4855 5.69219 13.2224 5.69273 11.9255C5.69423 8.14066 8.78822 5.06156 12.5928 5.06156C14.4352 5.06232 16.1668 5.77725 17.4691 7.07466C18.7714 8.37207 19.488 10.0968 19.4875 11.9311C19.4858 15.7159 16.3917 18.7955 12.5902 18.7955Z' fill='%23264EB1'/%3E%3C/svg%3E%0A\")";

  type TContactPerson = {
    name: null | string;
    job_title: null | string;
    email: null | string;
    avatar: null | string;
    whatsapp: null | string;
    telegram: null | string;
  };

  type TContactType = {
    type: 'email' | 'whatsapp' | 'telegram';
    value: string;
  };

  type TContactsObj = {
    other: TContactType[];
    messengers: TContactType[];
  };

  export default defineNuxtComponent({
    name: 'AdsContactList',
    components: {
      // AdsContactPicture,
    },
    props: {
      elem: {
        type: Object,
        required: true,
      } as PropOptions<TContent>,
    },

    computed: {
      title(): string {
        return this.elem.attributes.title ?? 'Контакты';
      },

      items(): TContactPerson[] {
        return this.elem.attributes.items;
      },
      iconVariables(): string {
        return `
      --icon-color-tg: ${iconTg};
      --icon-color-tg-before: ${iconTgBefore};
      --icon-color-whatsapp: ${iconWhatsapp};
      --icon-color-whatsapp-before: ${iconWhatsappBefore}
      `;
      },
    },

    methods: {
      getPersonInfo(contact: TContactPerson): string {
        if (!contact.name && !contact.job_title) {
          return '';
        }

        const jobTitle = contact.job_title ? `, ${contact.job_title}` : '';

        const colon = contact.email || contact.whatsapp || contact.telegram ? ':' : '';

        return `<span style="font-weight: 600">${contact.name ?? ''}</span>${jobTitle}${colon}`;
      },

      getPersonContacts(contactPerson: TContactPerson): TContactsObj {
        const { email, whatsapp, telegram } = contactPerson;
        const contacts = {
          other: [] as TContactType[],
          messengers: [] as TContactType[],
        };

        if (email) {
          contacts.other.push(this.createContact('email', email));
        }

        if (telegram) {
          contacts.messengers.push(this.createContact('telegram', telegram));
        }
        if (whatsapp) {
          contacts.messengers.push(this.createContact('whatsapp', whatsapp));
        }

        return contacts;
      },

      createContact(type: TContactType['type'], value: string): TContactType {
        return {
          type,
          value,
        };
      },

      getClassContactLink(contact: any) {
        return {
          [`ads-contacts-list__contact-link--${contact.type}`]: contact.type,
        };
      },

      getHrefContact(contact: any): string {
        const hrefByType = {
          email: (value: string) => `mailto:${value}`,
          whatsapp: (value: string) => `https://api.whatsapp.com/send?phone=${value}`,
          telegram: (value: string) => `https://t.me/${value}`,
        } as Record<string, Function>;

        return typeof hrefByType[contact.type] === 'function'
          ? hrefByType[contact.type](contact.value)
          : contact.value;
      },

      getTextContact(contact: any): string {
        return contact.type === 'email' ? contact.value : '';
      },

      getContactAvatar(contact: any): string {
        return contact.image?.origin ?? '';
      },
    },
  });
</script>

<style lang="scss">
  .ads-contacts-list {
    & + br {
      content: '';
    }
  }
</style>
<style lang="scss" scoped>
  .ads-contacts-list {
    margin-top: 48px;
    margin-bottom: 32px;

    @include tablet {
      margin-top: 60px;
      margin-bottom: 40px;
    }

    &__title {
      @include fontH1;
      margin-bottom: 16px;

      @include tablet {
        margin-bottom: 24px;
      }
    }

    &__person {
      word-break: break-word;

      @include tablet {
        display: flex;
        align-items: flex-start;
      }

      & + & {
        @include tablet {
          .ads-contacts-list__avatar {
            margin-top: 30px;
          }
        }
        &:before {
          content: '';
          display: block;
          width: 40px;
          border-top: 1px solid #d4d7de;
          margin: 16px 0;
          @include tablet {
            width: 0;
          }
        }
        .ads-contacts-list__person-info {
          @include tablet {
            &:before {
              content: '';
              display: block;
              width: 40px;
              border-top: 1px solid #d4d7de;
              margin: 16px 0;
            }
          }
        }
      }
    }

    &__avatar {
      @include tablet {
        width: 40px;
        margin-right: 16px;
      }

      > img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        object-fit: contain;
      }
    }

    &__contacts-wrapp {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }

    &__contacts {
      &--other {
        padding-right: 14px;
        position: relative;
        margin-right: 15.6px;
        &:not(:last-child) {
          &::after {
            content: '';
            position: absolute;
            height: 12px;
            width: 1px;
            right: 0;
            top: 8px;
            transform: translateX(100%);
            background: #d4d7de;
          }
        }
      }

      &--messengers {
        flex-shrink: 0;
        position: relative;
        //&::before {
        //  width: 100%;
        //  height: 1px;
        //  margin: 8px 0;
        //  content: '';
        //}
      }
    }

    &__contact {
      &-link {
        // @include fontTextBtn;
        // font-weight: normal;
        // color: #2962F9;
        position: relative;

        & + & {
          margin-left: 14px;
        }

        &--email {
          @include linkStyle;
          white-space: nowrap;
        }

        &--telegram,
        &--whatsapp {
          display: inline-block;
          margin-top: 8px;
          width: 24px;
          height: 24px;

          &:before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            opacity: 0;
            z-index: 0;
          }

          @include hover {
            &:before {
              opacity: 1;
              z-index: 1;
            }
          }
        }

        &--telegram {
          background-image: var(--icon-color-tg);
          &:before {
            background-image: var(--icon-color-tg-before);
          }
        }

        &--whatsapp {
          background-image: var(--icon-color-whatsapp);
          &:before {
            background-image: var(--icon-color-whatsapp-before);
          }
        }
      }
    }
  }
</style>
